<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$t('base.pp.pickupPoint')" prop="pickupPoint">
                <el-input class="handle-input" v-model="queryCondition.pickupPoint" clearable style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('common.status')" prop="status">
                <el-select v-model="queryCondition.status" clearable style="width:100%">
                  <el-option :label="$t('common.all')" value=""></el-option>
                  <el-option :key="index" v-for="(item,index) in statusList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-button size="mini" type="primary" @click="queryData(1)">{{$t('common.search')}}</el-button>
            <el-button size="mini" type="primary" @click="restQueryForm">{{$t('common.reset')}}</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" v-acl="PickupPointNew" @click="showPickupPointDialog('add')">{{$t('common.addNew')}}</el-button>
        <el-button size="mini" class="btn" type="danger" v-acl="PickupPointDel" @click="delSelPickupPoint">{{$t('common.del')}}</el-button>
      </el-row>
      <el-table sortable max-height="435" :data="pickupPointList" ref="pickupPointDataTable" border highlight-current-row class="table">
        <el-table-column align="center" sortable prop="tmPickupPointId" type="selection" width="55"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="pickupPoint" :label="$t('base.pp.pickupPoint')">
          <template slot-scope="scope">
            <el-link type="primary" @click="showPickupPointDialog('update',scope.row)"> {{scope.row.pickupPoint}}</el-link>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="name" :label="$t('common.updateBy')"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="updateDate" :label="$t('common.updateDate')">
          <template slot-scope="scope">
            {{scope.row.updateDate | dateFormatFilter("YYYY-MM-DD HH:mm")}}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="statusI18n" :label="$t('common.status')"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
    <!--=========数据列表END================-->
    <!--=========提货点添加/修改=========-->
    <el-dialog :title="$t('base.pp.pickupPointInfo')" :visible.sync="pickupPointDialog" width="600px">
      <el-form :model="pickupPointInfo" ref="pickupPointForm" class="form_border" :rules="dcRules" :label-position="labelPosition" label-width="120px">
        <el-row type="flex" justify="space-around">
          <el-col :span="16">
            <el-form-item :label="$t('base.pp.pickupPoint')" placeholder="" prop="pickupPoint">
              <el-input v-model="pickupPointInfo.pickupPoint" class="handle-input" />
            </el-form-item>

            <el-form-item :label="$t('common.status')" placeholder="" prop="status">
              <el-select v-model="pickupPointInfo.status" class="handle-input">
                <el-option :label="$t('common.sel')" value=""></el-option>
                <el-option :key="index" v-for="(item,index) in statusList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button size="mini" type="primary" @click="pickupPointDialog = false">{{$t('common.close')}}</el-button>
        <el-button size="mini" type="primary" @click="savePickupPoint">{{$t('common.save')}}</el-button>
      </div>
    </el-dialog>
    <!--=========提货点添加/修改EN=========-->
  </div>
</template>
<script>
import { pickupPointService } from "../../../api/base-data/pickup-point";
import { inputChoiceService } from "../../../api/common/input-choice";
import { Message } from "element-ui";
export default {
  name: 'pickup-point',
  data() {
    return {
      totalCount: 0,
      pickupPointList: [],
      labelPosition: 'right',
      queryCondition: { 
        pageSize: 15, 
        pageNum: 1, 
        pickupPoint: "", 
        status: "" 
      },
      pickupPointDialog: false,
      pickupPointInfo: {},
      dcRules: {
        pickupPoint: [
          { required: true, message: this.$t('base.pp.inputPickupPoint'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('base.pp.inputStatus'), trigger: 'blur' }
        ]
      },
      method: "",
      statusList: [],
    }
  },
  created() {
    this.queryData(1);
    this.getInputChoiceValues();
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      pickupPointService.getPickupPointData(this.queryCondition).then((res) => {
        this.pickupPointList = res.resultData;
        this.totalCount = res.totalCount;
      });
    },
    //分页查询页数变化
    pageNumberChange(val) {
      this.queryCondition.pageNum = val;
      this.queryData();
    },
    //分页查询每页显示数量变化
    pageSizeChange(val) {
      this.queryCondition.pageSize = val;
      this.queryData();
    },
    //查询条件重置方法
    restQueryForm: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition.pageSize = 15;
      this.queryCondition.pageNum = 1;
    },
    showPickupPointDialog: function (method, row) {
      this.clearVlidate("pickupPointForm");
      this.method = method;
      if ('add' === method) {
        this.pickupPointInfo = {};
      } else {
        if (this.actionCheck.actionCheck('PickupPointEdit') === false) {
          this.$message.error(this.$t('common.noPermission'))
          return false
        }
        this.pickupPointInfo = row;
      }
      this.pickupPointDialog = true;
    },
    savePickupPoint: function () {
      let validFlag = false;
      this.$refs['pickupPointForm'].validate((valid) => {
        validFlag = valid;
      });
      if (!validFlag) {
        return;
      }
      pickupPointService.savePickupPoint(this.pickupPointInfo, this.method).then((res) => {
        if (res.meta.success) {
          Message({ message: this.$t('common.saveSuccess'), type: "success" });
          this.pickupPointDialog = false;
          this.queryData();
        } else {
          Message({ message: res.meta.msg, type: "error" });
          this.queryData();
        }
      });
    },
    //清除校验信息
    clearVlidate: function (refFormName) {
      if (this.$refs[refFormName]) {
        this.$refs[refFormName].clearValidate();
      }
    },
    delSelPickupPoint() {
      let rows = this.$refs.pickupPointDataTable.selection;
      if (rows.length == 0) {
        Message({ message: this.$t('base.pp.selectPickupPoint'), type: "warning" });
      } else {
        let ids = [];
        rows.forEach((item) => {
          ids.push(item.tmPickupPointId)
        });

        this.$confirm(this.$t('common.delWarning'), this.$t('common.tips'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          cancelButtonClass: 'el-button--primary',
          confirmButtonClass: 'el-button--primary',
          type: 'warning'
        }).then(() => {
          pickupPointService.deletePickupPoint(ids).then((res) => {
            if (res.meta.success) {
              Message({ message: this.$t('common.delSuccess'), type: "success" });
              this.selectRow = null;
              this.queryData();
            } else {
              Message({ message: this.$t('common.delError'), type: "error" });
            }
            this.queryData();
          });
        }).catch(() => {

        });
      }
    },
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["COMMON:STATUS_DISABLE_ENABLE"] = "COMMON:STATUS_DISABLE_ENABLE";
      inputChoiceService.getInputChoiceValues(mapObj).then((res) => {
        this.statusList = res["COMMON:STATUS_DISABLE_ENABLE"];
      });
    }
  }
}
</script>
<style scoped >
.handle-input {
  width: 95%;
}
.form_border {
  border: 1px solid #eaeefb;
  padding: 10px 10px 0;
}
</style>
